import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const ChevronUpIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15C18 15 13.5811 9 12 9C10.4188 9 6 15 6 15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 9C18 9 13.5811 15 12 15C10.4188 15 6 9 6 9"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ChevronLeftIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 18C15 18 9 13.5811 9 12C9 10.4188 15 6 15 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ChevronSmallLeftIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0019 4.5C10.0019 4.5 6.00195 7.44593 6.00195 8.5C6.00195 9.55413 10.0019 12.5 10.0019 12.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);
export const ChevronRightIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6.93481C9 6.93481 15 11.3537 15 12.9348C15 14.516 9 18.9348 9 18.9348"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronSmallRightIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00195 4.5C6.00195 4.5 10.002 7.44593 10.002 8.5C10.002 9.55413 6.00195 12.5 6.00195 12.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronSmallDownIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.96967 5.46967C3.26256 5.17678 3.73744 5.17678 4.03033 5.46967L8 9.43934L11.9697 5.46967C12.2626 5.17678 12.7374 5.17678 13.0303 5.46967C13.3232 5.76256 13.3232 6.23744 13.0303 6.53033L8.53033 11.0303C8.23744 11.3232 7.76256 11.3232 7.46967 11.0303L2.96967 6.53033C2.67678 6.23744 2.67678 5.76256 2.96967 5.46967Z"
      fill={color}
    />
  </svg>
);
export const ChevronSmallUpIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0303 10.5303C12.7374 10.8232 12.2626 10.8232 11.9697 10.5303L8 6.56066L4.03033 10.5303C3.73744 10.8232 3.26256 10.8232 2.96967 10.5303C2.67678 10.2374 2.67678 9.76256 2.96967 9.46967L7.46967 4.96967C7.76256 4.67678 8.23744 4.67678 8.53033 4.96967L13.0303 9.46967C13.3232 9.76256 13.3232 10.2374 13.0303 10.5303Z"
      fill={color}
    />
  </svg>
);
